import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

export interface PlusPromotionCodeItem {
  id: string
  code: string
  percentOff: number
  active: boolean
  timesRedeemed: number
  maxRedemptions: number | null
  expiresAt: number | null
  createdAt: number
}

export interface ListPlusPromotionCodesResult {
  listPlusPromotionCodesV2: PlusPromotionCodeItem[]
}

const QUERY = gql`
  query ListPlusPromotionCodes {
    listPlusPromotionCodesV2 {
      id
      code
      percentOff
      active
      timesRedeemed
      maxRedemptions
      expiresAt
      createdAt
    }
  }
`

export const useListPromotionCodes = () => {
  return useQuery<ListPlusPromotionCodesResult>(QUERY, {
    fetchPolicy: 'network-only',
  })
}
